const log = name => (...v) => console.log(name, ...v);

export default {
  identify: log("mixpanel.identify"),
  track: log("mixpanel.track"),
  people: {
    set: log("mixpanel.people.set"),
    append: log("mixpanel.people.append"),
    increment: log("mixpanel.people.increment")
  }
};



// WEBPACK FOOTER //
// ./src/store/mixpanel/mock.js